import { RootState } from '../redux';

export const selectNotifications = (store: RootState) => store.notifications.notifications ?? [];
